__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "developer-api-mfe-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.11.10", () => (Promise.all([__webpack_require__.e(167), __webpack_require__.e(914), __webpack_require__.e(212)]).then(() => (() => (__webpack_require__(88167))))));
			register("@tanstack/match-sorter-utils", "8.19.4", () => (__webpack_require__.e(22).then(() => (() => (__webpack_require__(46022))))));
			register("@tanstack/react-table", "8.20.5", () => (Promise.all([__webpack_require__.e(72), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(61072))))));
			register("antd", "5.22.2", () => (Promise.all([__webpack_require__.e(815), __webpack_require__.e(856), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(43856))))));
			register("graphql", "16.9.0", () => (__webpack_require__.e(926).then(() => (() => (__webpack_require__(37926))))));
			register("i18next-browser-languagedetector", "7.2.1", () => (__webpack_require__.e(127).then(() => (() => (__webpack_require__(17508))))));
			register("i18next", "23.16.8", () => (__webpack_require__.e(526).then(() => (() => (__webpack_require__(82526))))));
			register("js-cookie", "3.0.5", () => (__webpack_require__.e(468).then(() => (() => (__webpack_require__(35468))))));
			register("moment", "2.30.1", () => (Promise.all([__webpack_require__.e(29), __webpack_require__.e(358)]).then(() => (() => (__webpack_require__(95093))))));
			register("react-datepicker", "8.2.1", () => (Promise.all([__webpack_require__.e(182), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(22182))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-helmet", "6.1.0", () => (Promise.all([__webpack_require__.e(154), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(68154))))));
			register("react-i18next", "13.5.0", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(365)]).then(() => (() => (__webpack_require__(62365))))));
			register("react-router-dom", "6.28.0", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(92648))))));
			register("react-syntax-highlighter", "15.6.1", () => (Promise.all([__webpack_require__.e(200), __webpack_require__.e(914), __webpack_require__.e(825)]).then(() => (() => (__webpack_require__(78200))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
			register("ts-utils-lib", "0.0.7", () => (Promise.all([__webpack_require__.e(236), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(67236))))));
			register("ts-widgets", "0.0.43", () => (Promise.all([__webpack_require__.e(272), __webpack_require__.e(914), __webpack_require__.e(578), __webpack_require__.e(936)]).then(() => (() => (__webpack_require__(59272))))));
			register("zustand", "4.5.5", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(85)]).then(() => (() => (__webpack_require__(34085))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};